import HeroSection from '@/pages/home/components/HeroSection';
import CategoryCards from '@/pages/home/components/CategoryCards';
import FeaturedArticles from '@/pages/home/components/FeaturedArticles';
import FAQSection from '@/pages/home/components/FAQSection';
import Footer from '@/components/feature/Footer';
import Navbar from '@/components/feature/Navbar';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '吉泽明步粉丝资讯站',
    url: 'https://yoshizawa-fans.com',
    description: '全面介绍吉泽明步的个人资料、演艺经历、代表作品及相关信息。最权威、最详尽的粉丝资讯平台。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://yoshizawa-fans.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吉泽明步粉丝资讯站',
    url: 'https://yoshizawa-fans.com',
    description: '吉泽明步粉丝自发创建的资讯平台，致力于为粉丝提供最全面、最权威的吉泽明步相关信息。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@akihofans.com',
      contactType: 'customer support',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryCards />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}